import React from 'react'
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min'
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { data, error } from 'jquery';
import axios from 'axios'
import { updateToken } from '../authPages/BaseRequester';

function Card() {
    const elements = useElements();
    const stripe = useStripe();
    const handleSubmit = async (e) => {
        e.preventDefault();

        var token = await updateToken();
        const header = `Authorization: Bearer ${token}`;
        const config = {
            headers: { "Authorization": `Bearer ${token}` }
        }
        if (!stripe || !elements) {
            return;
        }
        alert('creating payment intent')
        const res = await axios.post('https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyown/api/v1/user/pay', { email: 'waliidahsan@gmail.com' }, config);

        const clientSecret = res.data['client_secret'];
        const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardElement),
            }
        })
        if (stripeError) {
            alert(stripeError.message);
            return;
        }
        if (paymentIntent.status == "succeeded") {
            alert('payment succeeded')
        } else {
            alert('payment failed')
        }
    }
    return (
        <>
            <form id="payment-form" onSubmit={handleSubmit}>
                <label htmlFor='card-element'>Card</label>
                <CardElement id='card-element' />
                <button>pay</button>

            </form>
        </>
    )
}

export default withRouter(Card);